export default __webpack_public_path__ + "bbe93fa1d61a942a09f4d7966e93c099.svg";